"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function ITransactionFromJSON(json) {
    return ITransactionFromJSONTyped(json, false);
}
exports.ITransactionFromJSON = ITransactionFromJSON;
function ITransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'account': !runtime_1.exists(json, 'account') ? undefined : json['account'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'start': !runtime_1.exists(json, 'start') ? undefined : (new Date(json['start'])),
        'complete': !runtime_1.exists(json, 'complete') ? undefined : (json['complete'] === null ? null : new Date(json['complete'])),
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'paymentMethod': !runtime_1.exists(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'amount': !runtime_1.exists(json, 'amount') ? undefined : json['amount'],
        'fees': !runtime_1.exists(json, 'fees') ? undefined : json['fees'],
        'currency': !runtime_1.exists(json, 'currency') ? undefined : json['currency'],
        'transactionId': !runtime_1.exists(json, 'transactionId') ? undefined : json['transactionId'],
        'transactionType': !runtime_1.exists(json, 'transactionType') ? undefined : json['transactionType'],
        'transactionStatusCode': !runtime_1.exists(json, 'transactionStatusCode') ? undefined : json['transactionStatusCode'],
        'provider': !runtime_1.exists(json, 'provider') ? undefined : json['provider'],
        'relatedEntityIds': !runtime_1.exists(json, 'relatedEntityIds') ? undefined : json['relatedEntityIds'],
        'entityId': !runtime_1.exists(json, 'entityId') ? undefined : json['entityId'],
        'properties': !runtime_1.exists(json, 'properties') ? undefined : json['properties'],
        'integration': !runtime_1.exists(json, 'integration') ? undefined : _1.IntegrationFromJSON(json['integration']),
        'belongsTo': !runtime_1.exists(json, 'belongsTo') ? undefined : json['belongsTo'],
    };
}
exports.ITransactionFromJSONTyped = ITransactionFromJSONTyped;
function ITransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'complete': value.complete === undefined ? undefined : (value.complete === null ? null : value.complete.toISOString()),
        'paymentMethod': value.paymentMethod,
        'fees': value.fees,
        'transactionId': value.transactionId,
        'transactionStatusCode': value.transactionStatusCode,
        'properties': value.properties,
        'integration': _1.IntegrationToJSON(value.integration),
    };
}
exports.ITransactionToJSON = ITransactionToJSON;
